import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { type UrlParams } from '../types';

import { shopByUsernameQueryOptions } from '@/modules/shop/queries';

export function useShopByUsername() {
  const { username } = useParams<UrlParams>();

  return useQuery(shopByUsernameQueryOptions(username));
}
